export default __webpack_public_path__ + "static/media/noun_Money_3751165.8cf87da4.svg";